import * as React from 'react'

import { cn, formatDate } from '@/lib/utils'

type PhotosListIntroProps = {
  header: string
  date?: string
  subheader?: string
  className?: string
}

export default function PhotosListIntro({
  header,
  date,
  subheader,
  className,
}: PhotosListIntroProps) {
  return (
    <div
      className={cn(
        'flex h-[100svh] flex-col items-center justify-center px-4 md:px-8',
        className,
      )}
    >
      <header className='text-center'>
        {date && <p className='p--small mb-1'>{formatDate(date, true)}</p>}
        <h1 className='h1'>{header}</h1>
        {subheader && <h2 className='pt-4'>{subheader}</h2>}
      </header>
    </div>
  )
}
